import { Box, Modal } from "@mui/material";
import React from "react";

const style = {
  position: "absolute",
  top: { xs: "60%", sm: "50%" },
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "342px" },
  bgcolor: "#fff",
  p: 1,
  borderRadius: "4px",
  border: "none",
  height: "140px",
  textAlign: "center",
};

const Deletepopup = ({ isOpen, setisOpen, handledelete }) => {
  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => setisOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          backgroundColor: "rgb(0, 0, 0, 0.55)",
        }}
      >
        <Box sx={style}>
          <h2 className="kyctitle">Are you sure want to delete?</h2>
          {/* <p className="kycdes">
          To receive payments, please complete your KYC process.
        </p> */}
          <div className="kycbuttons">
            <button onClick={() => setisOpen(false)}>Cancel</button>

            <button onClick={handledelete}>Delete</button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Deletepopup;
